import {
  deselectAnnotation,
  deselectAnnotations,
  selectAnnotation,
  selectAnnotations,
} from '@/stores/layout';
import { Annotation } from '@/utils/entities';
import { ChangeEvent } from 'react';

export type IsNodeChecked = (
  annotations: Annotation[],
  annotationIdsObject: Record<string, boolean>,
) => boolean;

export type IsNodeIndeterminate = (
  annotations: Annotation[],
  annotationIdsObject: Record<string, boolean>,
) => boolean;

export type HandleNodeChange = (annotations: Annotation[], isChecked: boolean) => void;

export type HandleAnnotationNodeChange = (e: ChangeEvent<HTMLInputElement>, id: string) => void;

export const useTreeNodeActions = () => {
  const isNodeChecked = (
    annotations: Annotation[],
    annotationIdsObject: Record<string, boolean>,
  ) => {
    if (annotations.length === 0) {
      return false;
    }
    return annotations.every(annotation => annotationIdsObject[annotation.id]);
  };

  const isNodeIndeterminate = (
    annotations: Annotation[],
    annotationIdsObject: Record<string, boolean>,
  ): boolean => {
    const total = annotations.length;
    const checked = annotations.filter(a => annotationIdsObject[a.id]).length;

    return checked > 0 && checked < total;
  };

  const handleNodeChange = (annotations: Annotation[], isChecked: boolean) => {
    const annotationIds = annotations.map(annotation => annotation.id);
    if (isChecked) {
      deselectAnnotations(annotationIds);
    } else {
      selectAnnotations(annotationIds);
    }
  };

  const handleAnnotationNodeChange = (e: ChangeEvent<HTMLInputElement>, id: string) => {
    if (e.target.checked) {
      selectAnnotation(id);
    } else {
      deselectAnnotation(id);
    }
  };

  return [isNodeChecked, handleNodeChange, handleAnnotationNodeChange, isNodeIndeterminate];
};
